import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { SnackbarService } from '../../snackbar/service/snackbar.service';
import { AttachmentModel } from 'src/app/core/models/attachment.model';

@Component({
  selector: 'app-modal-files-upload',
  templateUrl: './modal-files-upload.component.html',
  styleUrls: ['./modal-files-upload.component.scss']
})
export class ModalFilesUploadComponent {

  @ViewChild('uploadBtnRef', { read: ElementRef, static: true }) uploadBtn: ElementRef;
  @ViewChild('gridUploadBtnRef', { read: ElementRef, static: true }) gridUploadBtn: ElementRef;
  @ViewChild('gridUploadBtn2Ref', { read: ElementRef, static: true }) gridUploadBtn2: ElementRef;

  @Input() hide: boolean;
  @Output() closeM: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() finish: EventEmitter<any[]> = new EventEmitter<any[]>();

  attachedFiles: AttachmentModel[] = [];
  attachedFilesSession: AttachmentModel[] = [];
  allowedExtensions = [
    'doc',
    'docx',
    'jpg',
    'jpeg',
    'pdf',
    'png',
    'ppt',
    'pptx',
    'xls',
    'xlsx'
  ];

  private iconExt = {
    doc: 'word',
    docx: 'word',
    pdf: 'pdf',
    ppt: 'powerpoint',
    pptx: 'powerpoint',
    xls: 'excel',
    xlsx: 'excel'
  };

  constructor(private snackSvc: SnackbarService) { }

  async verifyFiles(source: string) {
    const filesArray: File[] = this.getSourceFiles(source);
    for (const file of filesArray) {
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (this.allowedExtensions.includes(fileExtension)) {
        if (file.size < 2097153) {
          const icon: string = this.iconExt[fileExtension] || null;
          const readFile = await this.getBase64(file);
          if (this.attachedFilesSession.length < 9) {
            if (this.verifyDuplicate(readFile)) {
              this.attachedFilesSession.push({
                name: file.name,
                file,
                fileExt: fileExtension,
                icon,
                content_type: file.type,
                content: readFile
              });
            } else {
              this.snackSvc.show('Arquivo duplicado.', 'error');
            }
          } else {
            this.snackSvc.show('Limite de arquivos atingido.', 'error');
          }
        } else {
          this.snackSvc.show('Limite máximo por arquivo é de 2MB.', 'error');
        }
      } else {
        this.snackSvc.show('Tipo de arquivo não permitido.', 'error');
      }
    }
    this.clearFileInputs();
  }

  getSourceFiles(source: string): File[] {
    if (source === 'grid' && this.gridUploadBtn.nativeElement.files && this.gridUploadBtn.nativeElement.files.length > 0) {
      return this.gridUploadBtn.nativeElement.files;
    }
    if (source === 'grid2' && this.gridUploadBtn2.nativeElement.files && this.gridUploadBtn2.nativeElement.files.length > 0) {
      return this.gridUploadBtn2.nativeElement.files;
    }
    if (source === 'button' && this.uploadBtn.nativeElement.files && this.uploadBtn.nativeElement.files.length > 0) {
      return this.uploadBtn.nativeElement.files;
    }
    return [];
  }

  verifyDuplicate(readFile: any): boolean {
    let unique = true;
    this.attachedFilesSession.forEach(attach => {
      if (attach.content === readFile) {
        unique = false;
      }
    });
    return unique;
  }

  clearFileInputs(): void {
    this.gridUploadBtn.nativeElement.value = '';
    this.gridUploadBtn2.nativeElement.value = '';
    this.uploadBtn.nativeElement.value = '';
  }

  removeAttachedFile(idx: number): void {
    if (this.attachedFilesSession.length === 0) {
      return;
    }
    this.attachedFilesSession.splice(idx, 1);
  }

  getBase64(baseFile: File): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(baseFile);
      reader.onload = (item: any) => {
        resolve(item.target.result);
      };
      reader.onerror = error => {
        reject(null);
      };
    });
  }

  confirmUpload() {
    const files = [];
    this.attachedFiles = this.attachedFilesSession.concat();
    this.attachedFiles.forEach(file => {
      files.push({
        name: file.name,
        content_type: file.content_type,
        content: file.content
      });
    });
    this.finish.emit(files);
  }

  cancelUpload() {
    this.closeM.emit(true);
    this.attachedFilesSession = this.attachedFiles.concat();
  }
}
